import type { ApolloQueryResult } from '@apollo/client';
import { GqlGetDutchiePosLoyaltyConfigQuery, useGetDutchiePosLoyaltyConfigQuery } from 'types/graphql';

type UseGetDutchiePosLoyaltyConfigProps = {
  dispensaryId?: string;
  enterpriseId?: string;
  isoRegionCode?: string;
  skip?: boolean;
};

type UseGetDutchiePosLoyaltyConfigReturn = {
  data: GqlGetDutchiePosLoyaltyConfigQuery['getDutchiePosLoyaltyConfig'] | undefined;
  loading: boolean;
  refetch: () => Promise<ApolloQueryResult<GqlGetDutchiePosLoyaltyConfigQuery>>;
};

export const useGetDutchiePosLoyaltyConfig = ({
  dispensaryId,
  enterpriseId,
  isoRegionCode,
  skip = false,
}: UseGetDutchiePosLoyaltyConfigProps): UseGetDutchiePosLoyaltyConfigReturn => {
  const skipQuery = skip || (!dispensaryId && !enterpriseId);

  const { data, loading, refetch } = useGetDutchiePosLoyaltyConfigQuery({
    variables: {
      dispensaryId,
      enterpriseId,
      isoRegionCode,
    },
    fetchPolicy: 'network-only',
    skip: skipQuery,
  });

  return {
    data: data?.getDutchiePosLoyaltyConfig,
    loading,
    refetch,
  };
};
